<template>
    <SearchStepModal>
        <template #title>Target Job Stage</template>
        <template #content>
            <div v-if="isCycleRestarted">
                <p class="font-bold">Why are you back here?</p>
                <p>
                    Your JobTrackerAI data shows an interview rate below 2%. This isn't failure - it's market feedback
                    indicating your target role doesn't align with your experience, or your resume isn't effectively
                    showcasing relevant skills.
                </p>
                <br />
                <p class="font-bold">Why this matters:</p>
                <p>
                    Recruiters seek specialists with precisely the skills needed for specific roles. When your
                    background doesn't naturally align with your target position, securing interviews becomes
                    significantly harder.
                </p>
                <br />
                <p class="font-bold">Take these steps now:</p>
                <ul class="list-disc marker:font-bold ml-4">
                    <li>Identify which applications received any response</li>
                    <li>Find patterns in roles that better match your background</li>
                    <li>Select ONE target position where your experience makes you a specialist</li>
                    <li>Consider adjacent roles using similar skills</li>
                </ul>
                <br />
                <p class="font-bold">The data-driven advantage:</p>
                <p>
                    Job seekers who pivot to better-aligned roles based on feedback often see interview rates jump from
                    under 2% to 5-10%. The right target role can triple your opportunities by positioning you as exactly
                    what employers need.
                </p>
                <br />
                <p class="font-bold">Next stage:</p>
                <p>Resume Stage - Update your resume to highlight relevant experience for your new direction.</p>
            </div>
            <div v-else>
                <p>
                    The <span class="font-bold">biggest mistake</span> most job seekers make is trying to be everything
                    to everyone.
                </p>
                <br />
                <p>
                    Recruiters aren't looking for someone who "just needs a job" - they're hiring specialists who can
                    solve specific problems.
                </p>
                <br />
                <p>
                    This isn't about limiting your options forever. You can pursue multiple job paths, but each one
                    requires its own focused approach.
                </p>
                <br>
                <p class="font-bold">Exact steps:</p>
                <ul class="list-disc marker:font-bold ml-4">
                    <li>Choose ONE target job title (Marketing Manager, Data Analyst, etc.)</li>
                    <li>Research what skills and experience employers are asking for</li>
                    <li>
                        Connect JobTrackerAI to gain critical data-driven insights into your entire job search process
                    </li>
                </ul>
                <br />
                <p class="font-bold">Next stage:</p>
                <p>
                    Resume Stage - With your target role identified, you'll optimize your resume to pass the "6-second
                    test" that recruiters use when scanning applications.
                </p>
                <br />
                <p>Need help choosing your target role?</p>

                <p
                    @click="openCourseHandler"
                    class="text-won-blue font-bold underline underline-offset-2 cursor-pointer"
                >
                    Explore our course →
                </p>
            </div>
        </template>
        <template #button>{{
            isCycleRestarted ? "Explore Better-Matching Roles →" : "Connect JobTrackerAI Now →"
        }}</template>
    </SearchStepModal>
</template>
<script setup>
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useJobSearchPlanStore } from "../../../store/job-search-plan.store";
import SearchStepModal from "../search-step-modal.vue";

const jobSearchPlanStore = useJobSearchPlanStore();
const router = useRouter();

const { isCycleRestarted, showModal } = storeToRefs(jobSearchPlanStore);

const openCourseHandler = () => {
    router.push({ name: "learning-hub-courses" });
    showModal.value = false;
};
</script>
